module.exports = __webpack_public_path__ + "img/IMG_2629_P_L_Black.625c4352.jpg";